import { CloudMark, Wordmark } from './CloudFrugalLogo';

const DARK = '#07281D';
const GOLD = '#E8B84C';
const FONT = '"Plus Jakarta Sans", system-ui, sans-serif';

const links = [
  { label: 'Features', href: '/#features' },
  { label: 'Blog', href: '/blog' },
  { label: 'Frugal Cloud Guide', href: '/cheatsheet' },
  { label: 'Privacy', href: '#' },
  { label: 'Terms', href: '#' },
];

export default function Footer() {
  return (
    <footer className="py-6 px-4" style={{ background: DARK }}>
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <CloudMark size={36} primaryColor="#ffffff" midColor="rgba(255,255,255,0.5)" accentColor={GOLD} />
          <Wordmark size={14} variant="dark" />
        </div>
        <nav className="flex flex-wrap justify-center gap-x-5 gap-y-1">
          {links.map(l => (
            <a key={l.label} href={l.href} className="text-xs transition-colors hover:text-white" style={{ color: 'rgba(255,255,255,0.4)' }}>
              {l.label}
            </a>
          ))}
        </nav>
        <span className="text-xs" style={{ color: 'rgba(255,255,255,0.25)', fontFamily: FONT }}>
          © {new Date().getFullYear()} CloudFrugal
        </span>
      </div>
    </footer>
  );
}
